import {
  Button as AntButton,
  Modal,
  Select,
  Table,
  TableColumnsType,
} from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useAxios from '../../../../hooks/useAxios';
import { IGetSchools, ISchool } from '../../../../models/schools.model';
import { RootState } from '../../../../store/rootReducer';
import Button from '../../../Button';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';
import Pagination from '../../../Pagination';
import config from '../../../../lib/config';
import { getCommonCodeLabel } from '../../../../lib/store';
import { getSchools } from '../../../../api/schools.api';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  studentInputReq: any;
  setStudentInputReq: (studentInputReq: any) => void;
}

const SelectSchoolModal: FC<IProps> = ({
  visible,
  setVisible,
  studentInputReq,
  setStudentInputReq,
}) => {
  const { t } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0013 = 학교 구분
  const SY0013 = commonCodes.find(
    (item) => item.commonCode === 'SY0013',
  )?.detailCode;
  const { data: res, isLoading, error, execute } = useAxios<IGetSchools>();

  const [schoolDiv, setSchoolDiv] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [data, setData] = useState<ISchool[]>([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (res && !isLoading) {
      setData(res.data);
    }
  }, [res, isLoading]);

  const onClose = () => {
    setSchoolName('');
    setVisible(false);
  };

  const onSearch = () => {
    const req: any = {};
    if (schoolDiv) req.schoolDiv = schoolDiv;
    if (schoolName) req.schoolName = schoolName;

    execute(getSchools(req));
  };

  const columns: TableColumnsType<any> = [
    {
      title: t('student.student.column65'),
      dataIndex: 'schoolDiv',
      key: 'schoolDiv',
      render: (value) => getCommonCodeLabel('SY0013', value, 'ko'),
    },
    {
      title: t('system.school.column2'),
      dataIndex: 'schoolName',
      key: 'schoolName',
      sorter: (a, b) => a.schoolName?.localeCompare(b.schoolName),
    },
    {
      title: t('system.school.column4'),
      dataIndex: 'address',
      key: 'address',
      sorter: (a, b) => a.address?.localeCompare(b.address),
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        className="select-agent-modal"
        title={t('student.student.title2')}
        visible={visible}
        onCancel={onClose}
        width={600}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="submit" className='btn-basic gray' onClick={onClose}>
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div>
          <div className="flex flex-justify-end comm-gap">
            <div className="w-150p">
              <Select
                className="w-100"
                placeholder={t('student.student.83')}
                value={schoolDiv}
                onChange={(value) => setSchoolDiv(value)}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {SY0013?.map((item: any) => {
                  return (
                    <Select.Option
                      key={item.detailCode}
                      value={item.detailCode}
                    >
                      {item.korName}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
            <div className="w-210p">
              <input
                type="text"
                className="form-control"
                placeholder={t('system.school.column2')}
                value={schoolName}
                onChange={(e) => setSchoolName(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') onSearch();
                }}
              />
            </div>
            <div className='comm-btn__area'>
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </div>
          {data.length > 0 ? (
            <>
              <Table
                className='comm-table__area'
                columns={columns}
                dataSource={data}
                pagination={{
                  current: page,
                  pageSize: config.miniPageSize,
                }}
                onRow={(record) => {
                  return {
                    onClick: () => {
                      setStudentInputReq({
                        ...studentInputReq,
                        schoolCode: record.schoolCode,
                        schoolName: record.schoolName,
                      });
                      setVisible(false);
                    },
                  };
                }}
                rowClassName="pointer"
              />
              <div className="comm-bx__space">
                <div className="common-paging center">
                  <Pagination
                    count={data.length}
                    page={page}
                    setPage={setPage}
                    mini
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="comm-nodata-area">{t('student.student.text11')}</div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default SelectSchoolModal;
